/* No mock plan ID is ever submitted. Prices for real subscriptions come from Shopify. */
(() => {
  'use strict';
  const flT = globalThis.FellinoI18n.text;
  window.FellinoFoodSubscription = {
    create(product, onChange) {
      const box = product.querySelector('[data-food-subscription]');
      if (!box) return null;
      const q = selector => box.querySelector(selector);
      const demo = box.dataset.demo === 'true';
      const required = box.dataset.required === 'true';
      const data = JSON.parse(q('[data-subscription-data]').textContent);
      const money = new Intl.NumberFormat(box.dataset.locale || document.documentElement.lang || 'de-DE', {minimumFractionDigits:2, maximumFractionDigits:2});
      // Only native net-content measurements are usable here; shipping weight is not fill quantity.
      const units = {mg:['mass',0.001],g:['mass',1],kg:['mass',1000],ml:['volume',1],cl:['volume',10],l:['volume',1000],m:['length',1],cm:['length',0.01],mm:['length',0.001],m2:['area',1],m3:['volume-m3',1]};
      function unitTextFor(variant, price, nativePrice) {
        const measurement = data[String(variant?.id)]?.measurement;
        if (!measurement) return '';
        const quantity = Number(measurement.quantityValue);
        const reference = Number(measurement.referenceValue);
        const quantityUnit = units[String(measurement.quantityUnit).toLowerCase()];
        const referenceUnit = units[String(measurement.referenceUnit).toLowerCase()];
        let cents = Number(nativePrice);
        if (nativePrice === null || nativePrice === undefined || !Number.isFinite(cents)) {
          if (!quantityUnit || !referenceUnit || quantityUnit[0] !== referenceUnit[0] || !(quantity > 0) || !(reference > 0) || !Number.isFinite(Number(price))) return '';
          cents = Math.round(Number(price) * reference * referenceUnit[1] / (quantity * quantityUnit[1]) + 1e-8);
        }
        if (!(reference > 0) || !measurement.referenceUnit || cents < 0) return '';
        const unit = `${reference === 1 ? '' : reference}${String(measurement.referenceUnit).toLowerCase()}`;
        return `${money.format(cents / 100)}\u00a0${box.dataset.currency} / ${unit}`;
      }
      function showUnit(selector, text) {
        const element = q(selector);
        if (!element) return;
        element.textContent = text;
        element.hidden = !text;
      }
      const select = q('[data-subscription-plan]');
      const radios = [...box.querySelectorAll('[data-purchase-mode]')];
      const choices = [...box.querySelectorAll('[data-purchase-choice]')];
      const planOptions = [...select.options].filter(option => option.value);
      // Shopify keeps creation order; present delivery intervals from shortest to longest.
      const intervalDays = option => {
        const match = option.textContent.trim().match(/^(\d+)\s+(Wochen?|Monate?|weeks?|months?)/i);
        return match ? Number(match[1]) * (/^(monat|month)/i.test(match[2]) ? 30.44 : 7) : Infinity;
      };
      planOptions.sort((a, b) => intervalDays(a) - intervalDays(b)).forEach(option => select.append(option));
      const recommendedPlan = planOptions.find(option => option.hasAttribute('data-recommended'));
      let mode = required || (!demo && select.value) ? 'subscription' : 'once';
      let selected = demo ? 'preview-month-1' : select.value;
      let allocation = null;
      let availablePlans = [];
      let activeVariant = null;
      let ready = false;

      q('[data-subscription-choices]').hidden = false;
      q('[data-subscription-select-label]').textContent = flT("saef38dc70616");
      // Without JS, the native select is a functional fallback. Enhanced UI uses radios for one-time purchases.
      [...select.options].filter(option => !option.value).forEach(option => option.remove());
      radios.forEach(radio => radio.addEventListener('change', () => {
        mode = radio.value;
        onChange();
      }));
      select.addEventListener('change', () => {
        selected = select.value;
        onChange();
      });
      product.querySelector('.fl-product-form').addEventListener('submit', event => {
        if (mode === 'subscription' && (demo || !allocation || !activeVariant?.available)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);

      function sync(variant) {
        activeVariant = variant;
        const variantData = data[String(variant?.id)];
        availablePlans = (variantData?.allocations || []).filter(plan => plan.recurring && plan.price === plan.perDeliveryPrice);
        const hasPlans = !!variant && (demo || availablePlans.length > 0);
        planOptions.forEach(option => {
          const available = !!variant && (demo || availablePlans.some(plan => String(plan.id) === option.value));
          option.disabled = !available;
          option.hidden = !available;
        });
        if (demo) {
          allocation = variantData ? {price:variantData.previewPrice, priceText:variantData.previewPriceText, savingsText:variantData.previewSavingsText} : null;
        } else {
          allocation = availablePlans.find(plan => String(plan.id) === selected);
          if (!allocation) {
            allocation = availablePlans.find(plan => String(plan.id) === recommendedPlan?.value) || availablePlans[0] || null;
            selected = allocation ? String(allocation.id) : '';
          }
        }
        if (allocation) allocation = {...allocation,unitText:unitTextFor(variant, allocation.price, allocation.unitPrice) || allocation.unitText || ''};
        if (!hasPlans && !required) mode = 'once';
        select.value = selected;
        select.disabled = demo || mode !== 'subscription' || !hasPlans;
        // Preview selector remains interactive but never has a selling_plan name.
        if (demo) select.disabled = mode !== 'subscription' || !hasPlans;
        radios.forEach(radio => {
          radio.checked = radio.value === mode;
          radio.disabled = radio.value === 'subscription' && !hasPlans;
        });
        choices.forEach(choice => {
          choice.dataset.selected = String(choice.dataset.purchaseChoice === mode);
          choice.dataset.unavailable = String(choice.dataset.purchaseChoice === 'subscription' && !hasPlans);
        });
        q('[data-subscription-details]').hidden = mode !== 'subscription' || !hasPlans;
        q('[data-subscription-unavailable]').hidden = hasPlans;
        if (q('[data-one-time-price]')) q('[data-one-time-price]').textContent = variant?.priceText || '–';
        q('[data-subscription-price]').textContent = allocation?.priceText || '–';
        showUnit('[data-one-time-unit]', variant?.unitText || unitTextFor(variant, variant?.price, variantData?.unitPrice));
        showUnit('[data-subscription-unit]', allocation?.unitText || '');
        const discount = variant?.price > 0 && allocation ? Math.round((variant.price - allocation.price) * 100 / variant.price) : 0;
        const badge = q('[data-subscription-badge]');
        badge.hidden = discount <= 0;
        badge.textContent = flT("s8b8a72dfe6ca",[ discount ]);
        q('[data-subscription-saving]').textContent = discount > 0 ? flT("s3063b43c92de",[ allocation.savingsText ]) : '';
        if (ready && !demo) {
          const url = new URL(location.href);
          if (mode === 'subscription' && allocation) url.searchParams.set('selling_plan', allocation.id);
          else url.searchParams.delete('selling_plan');
          history.replaceState({}, '', url);
        }
        ready = true;
      }

      return {
        sync,
        blocked: () => mode === 'subscription' && (demo || !allocation),
        buttonText: () => demo && mode === 'subscription' ? flT("sfda1a4d48caf") : null,
        priceFor(variant) {
          if (!variant) return variant;
          if (mode !== 'subscription' || !allocation) return {...variant,unitText:variant.unitText || unitTextFor(variant, variant.price, data[String(variant.id)]?.unitPrice)};
          return {...variant,price:allocation.price,priceText:allocation.priceText,compare:variant.price,compareText:variant.priceText,savingsText:allocation.savingsText,unitText:allocation.unitText,subscription:true};
        }
      };
    }
  };
})();
